import { formatDateTimeText } from './dateTimeText.js';
import { formatPhoneText } from './phoneText.js';

/** Presentation only: never replace stored messages or values sent to services. */
export function formatConversationText(text: string): string {
  return formatPhoneText(formatDateTimeText(text));
}
